module.exports = __webpack_public_path__ + "static/media/Cl6.91384b14.png";